import { getUserProfileRoute } from "@/src/helpers/getUserProfileRoute";
import { StoryTab } from "nvs-types/dist/types/generated/contentful";
import { IconContainer } from "../../icons/components/IconContainer";
import { MemberBadge } from "nvs-ds-icons/react/logos";
import { TextLink } from "../../links/components/TextLink";
import { Label4 } from "../../typography/components/Label";

type CocreatedWithProps = {
  swooshHandles: StoryTab["coCreatedWith"];
};

const CocreatedWith = ({ swooshHandles }: CocreatedWithProps) => {
  return (
    <div className="flex gap-3">
      <IconContainer>
        <MemberBadge />
      </IconContainer>
      <Label4>
        Co-created with{" "}
        {swooshHandles &&
          swooshHandles.map((swooshHandle, i) => {
            const profileLink = getUserProfileRoute(swooshHandle as string);
            return (
              <TextLink href={`${profileLink}`} key={`${swooshHandle}-${i}`}>
                {`${swooshHandle}.SWOOSH${
                  swooshHandles.length > 1 && swooshHandles.length - 1 !== i // if there's more than one creator and it's not the last one add a comma
                    ? ", "
                    : ""
                }`}
              </TextLink>
            );
          })}
      </Label4>
    </div>
  );
};

export default CocreatedWith;
